import { BUYING_HOUSE } from 'constants/constants';
import * as yup from 'yup';
import { getPartOfValidationSchema } from '../../helpers';

const validationSchema = yup
  .object()
  .shape({ ...getPartOfValidationSchema({ projectType: BUYING_HOUSE, groupName: 'outdoor' }) });

export default validationSchema;
